import $ from 'jquery';

export default function edvTicketsystem() {
    const prevButton = $(".back-to-ticket-list");
    const paginationControls = $("#pagination-memo");
    let rowsPerPage = 10;
    let currentPage = 1;
    let rows, numPages;
    rows = $('#memoTable tbody tr');
    if (rows.length > rowsPerPage) {
        numPages = Math.ceil(rows.length / rowsPerPage);
        updateContent();
        renderPagination();
        paginationControls.show();
    } else {
        rows.show();
        paginationControls.hide();
    }

    prevButton.on("click", function() {
        window.history.back();
    });

    function renderPagination() {
        let pages = '';
        if (numPages <= 5) {
            for (let i = 1; i <= numPages; i++) {
                pages += `<span class="page ${i === currentPage ? 'active' : ''}">${i}</span>`;
            }
        } else {
            if (currentPage < 5) {
                for (let i = 1; i <= 5; i++) {
                    pages += `<span class="page ${i === currentPage ? 'active' : ''}">${i}</span>`;
                }
                pages += ' ... <span class="page">' + numPages + '</span>';
            } else if (currentPage >= numPages - 4) {
                pages = '<span class="page">1</span> ... ';
                for (let i = numPages - 4; i <= numPages; i++) {
                    pages += `<span class="page ${i === currentPage ? 'active' : ''}">${i}</span>`;
                }
            } else {
                pages = '<span class="page">1</span> ... ';
                for (let i = currentPage - 1; i <= currentPage + 1; i++) {
                    pages += `<span class="page ${i === currentPage ? 'active' : ''}">${i}</span>`;
                }
                pages += ' ... <span class="page">' + numPages + '</span>';
            }
        }
        $('#page-num').html(pages);

    }

    $(".edv-tickets-container #table tbody").on("click", "tr", function() {
        const ticketId = $(this).data("ticket-id");
        if (ticketId) {
            const currentUrl = new URL(window.location.href);
            const params = currentUrl.searchParams;
            params.set('ticketId', ticketId);
            currentUrl.search = params.toString();
            window.location.href = currentUrl.toString();
        }

    });


    $(document).on('click', '.page', function() {
        let selectedPage = parseInt($(this).text());
        if (isNaN(selectedPage)) return;
        currentPage = selectedPage;
        updateContent();
        renderPagination();
        $('#go-to-page').val(currentPage);
    });

    $('#next').click(function(e) {
        e.preventDefault();
        if (currentPage < numPages) {
            currentPage++;
            updateContent();
            renderPagination();
            $('#go-to-page').val(currentPage);
        }
    });

    $('#prev').click(function(e) {
        e.preventDefault();
        if (currentPage > 1) {
            currentPage--;
            updateContent();
            renderPagination();
            $('#go-to-page').val(currentPage);
        }
    });

    $('#go').click(function(e) {
        e.preventDefault();
        let goToPage = parseInt($('#go-to-page').val());
        if (!isNaN(goToPage) && goToPage >= 1 && goToPage <= numPages) {
            currentPage = goToPage;
            updateContent();
            renderPagination();
            $('#go-to-page').val(currentPage);
        }
    })

    function updateContent() {
        const start = (currentPage - 1) * rowsPerPage;
        const end = start + rowsPerPage;
        rows.hide().slice(start, end).show();
        $('html, body').animate({
            scrollTop: 0
        }, 0);
    }

    $('.edv-refresh-table').click(function() {
        location.reload();
    });
}
